export default __webpack_public_path__ + "static/media/icon1.2b2d5817.svg";